import React from 'react'
import MenuButton from '@/v2/components/common/MenuButton'
import useModals from '@/v2/hooks/useModals'
import { useConsentForms } from '@/v2/hooks/documents/useConsentForm'
import IntakeForm from './IntakeForm'
import Contract from './Contract'
import ConsentForm from './ConsentForm'
import { Actions, List } from './styles'

const ContractsTab = ({
  patientId,
  email,
  intakeForm,
  contractList,
  hasActiveContract,
}) => {
  const { goTo } = useModals()
  const { consentForms } = useConsentForms()

  const contractOption = {
    label: 'Create contract',
    onClick: () =>
      goTo(`/v2/create-contract/${patientId}`, {
        initialValues: { email },
      }),
  }
  // The confirmation modal picks the form itself; the entry only opens it.
  // It is hidden until the list has a form, so a click before the query
  // resolves (or after it fails) no longer throws.
  const consentOption = {
    label: 'Create consent form',
    onClick: () => {
      goTo('/v2/consent-form-confirmation', { patientId })
    },
  }
  const options = [
    ...(!hasActiveContract ? [contractOption] : []),
    ...(consentForms?.length > 0 ? [consentOption] : []),
  ]

  return (
    <>
      <Actions>
        <MenuButton
          aria-label="+ Add Documents"
          title="+ Add Documents"
          variant="text"
          color="secondary"
          options={options}
          endIcon={<></>}
        >
          + Add Documents
        </MenuButton>
      </Actions>
      <List>
        <IntakeForm intakeForm={intakeForm} patientId={patientId} />
        <ConsentForm />
        {contractList.map(contract => (
          <Contract
            key={contract.id}
            contract={contract}
            patientId={patientId}
          />
        ))}
      </List>
    </>
  )
}

export default ContractsTab
